import cs from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC, ReactNode } from 'react';
import React, { useMemo } from 'react';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { LINKS } from '@/Module/Core/Constant';
import type { IBaseComponentProps } from '@/Module/Core/Model/DataModel';
enum SectionTypes {
  NONE,
  HOME,
  LEARNING,
  BLOG,
  TEACHER_LIST,
  QUESTION,
  CONTACT,
}
interface IDefaultLayoutFooterMenuProps extends IBaseComponentProps {}
interface IItemMenu {
  title: ReactNode;
  link: string;
  key: SectionTypes;
}
const DefaultLayoutFooterMenu: FC<IDefaultLayoutFooterMenuProps> = ({
  className
}) => {
  const router = useRouter();
  const isLoggedIn = useLoggedIn();
  const menuItems: IItemMenu[] = [{
    key: SectionTypes.HOME,
    link: isLoggedIn ? LINKS.LEARNING : LINKS.HOME,
    title: 'آی‌نو'
  }, {
    key: SectionTypes.LEARNING,
    link: LINKS.GRADE,
    title: 'درس‌ها'
  }, {
    key: SectionTypes.BLOG,
    link: LINKS.BLOG,
    title: 'روزنامه‌دیواری'
  }, {
    key: SectionTypes.TEACHER_LIST,
    link: LINKS.TEACHER_LIST,
    title: 'معلم‌ها'
  }, {
    key: SectionTypes.QUESTION,
    link: LINKS.QUESTION,
    title: 'شما پرسیدین'
  }, {
    key: SectionTypes.CONTACT,
    link: LINKS.CONTACT_US,
    title: 'تماس با ما'
  }];
  const activeMenu = useMemo(() => {
    switch (`${router.pathname}/`) {
      case LINKS.HOME:
        return SectionTypes.HOME;
      case LINKS.BLOG:
        return SectionTypes.BLOG;
      case LINKS.GRADE:
        return SectionTypes.LEARNING;
      case LINKS.TEACHER_LIST:
        return SectionTypes.TEACHER_LIST;
      case LINKS.QUESTION:
        return SectionTypes.QUESTION;
      case LINKS.CONTACT_US:
        return SectionTypes.CONTACT;
      default:
        return SectionTypes.NONE;
    }
  }, [router.pathname]);
  return <ul className={cs('flex w-full flex-row items-center gap-12 lg:gap-16 ', className)} data-sentry-component="DefaultLayoutFooterMenu" data-sentry-source-file="DefaultLayoutFooterMenu.tsx">
      {menuItems.map(item => <li key={item.key} className={cs('mobile-hover:ui__text-stroke-blueFive hover:ui__text-stroke-white transition-all duration-100 ease-in-out', item.key === activeMenu && 'font-bold')}>
          <Link className="mobile-hover:ui__text-stroke-blueFive  hover:ui__text-stroke-white transition-all duration-100 ease-in-out" href={item.link}>
            {item.title}
          </Link>
        </li>)}
    </ul>;
};
export default DefaultLayoutFooterMenu;